import { render, staticRenderFns } from "./labelAutocompleteOption.vue?vue&type=template&id=22877026&scoped=true"
import script from "./labelAutocompleteOption.vue?vue&type=script&lang=js"
export * from "./labelAutocompleteOption.vue?vue&type=script&lang=js"
import style0 from "./labelAutocompleteOption.vue?vue&type=style&index=0&id=22877026&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22877026",
  null
  
)

export default component.exports